// Die Kette des Lernmodus. Sie fuehrt durch dieselben Handlungen, die der
// Modus "Gerät kennenlernen" vorzeigt — hier aber zum Selbermachen: jeder
// Schritt rueckt erst weiter, wenn sein Checker zufrieden ist.
//
// Bewusst NUR Handlungen. Themen, bei denen es nichts zu tun gibt (Akku,
// Signalstaerke, Softkeys, Kanalanzeige …) bleiben dem Modus
// "Gerät kennenlernen" ueberlassen; ein Schritt, den man nur weiterklicken
// kann, waere im Lernmodus eine leere Huelse.
//
// Form: { type, params, target, label }
//   type   — Schluessel in logic/checkers.js
//   target — was pulsierend markiert wird (dieselben Namen wie in
//            Erklaerungen.js; Display.vue kennt die inneren)
//
// Kanalnummern kommen aus Kanaele.js, nicht von Hand — so bleibt die Kette
// richtig, wenn dort etwas umbenannt oder umnummeriert wird.
import { kanaele } from './Kanaele.js'

const zs3 = kanaele.find(k => k.label === 'ZS 3')
const gruppe = kanaele.find(k => k.label === 'ZS KEE 1')

export const guideSteps = [
    { type: 'powerOn', params: {}, target: 'power', label: 'Schalte das Funkgerät ein' },
    { type: 'changeVolume', params: {}, target: 'volume', label: 'Ändere die Lautstärke' },
    {
        type: 'joinChannelByKeypad',
        params: { mode: zs3.mode, number: zs3.number },
        target: 'digits',
        label: `Drücke Dir und tippe ${zs3.number} (Kanal ${zs3.label})`
    },
    { type: 'exitChannel', params: {}, target: 'hangup', label: 'Verlasse den Kanal: rote Taste gedrückt halten' },
    {
        type: 'joinChannelFromList',
        params: { mode: gruppe.mode, number: gruppe.number },
        target: 'selectorG',
        label: `Wähle ${gruppe.label} diesmal über die Liste: Grp, dann Durchsuchen, blättern, OK`
    },
    { type: 'menuBack', params: {}, target: 'selectorD', label: 'Öffne ein Menü und geh mit «Zurück» wieder hinaus' },
    { type: 'transmit', params: {}, target: 'ptt', label: 'Halte die Sprechtaste gedrückt und sprich' },
    { type: 'exitChannel', params: {}, target: 'hangup', label: 'Verlasse den Kanal, bevor du das Gerät ausschaltest' },
    { type: 'powerOff', params: {}, target: 'power', label: 'Schalte das Funkgerät wieder aus' }
]
